/**
 * Сбрасывает все cookie, видимые через document.cookie.
 * HttpOnly и недоступные по path/domain всё равно остаются — их гасит только сервер (напр. POST /auth/logout).
 */
export function clearClientAccessibleCookies(): void {
	if (typeof document === "undefined") return;

	const rawNames = document.cookie
		.split(";")
		.map((part) => part.split("=")[0]?.trim())
		.filter((name): name is string => Boolean(name));

	const names = [...new Set(rawNames)];
	if (names.length === 0) return;

	const expire = "Thu, 01 Jan 1970 00:00:00 GMT";
	const { hostname, protocol } = window.location;
	const secure = protocol === "https:";
	const isProbablyIp =
		/^[\d.]+$/.test(hostname) || hostname.includes(":");

	const domains = isProbablyIp ? [hostname] : [hostname, `.${hostname}`];

	const variants: string[] = [
		`expires=${expire};max-age=0;path=/`,
		`expires=${expire};max-age=0;path=/;SameSite=Lax`,
	];
	if (secure) {
		variants.push(
			`expires=${expire};max-age=0;path=/;Secure`,
			`expires=${expire};max-age=0;path=/;SameSite=None;Secure`,
		);
	}

	for (const name of names) {
		for (const base of variants) {
			document.cookie = `${name}=;${base}`;
		}
		for (const domain of domains) {
			for (const base of variants) {
				document.cookie = `${name}=;${base};domain=${domain}`;
			}
		}
	}
}
